import { useTranslation } from 'react-i18next';
import InfoMessage from '.';

const NoSearchResultsInfoMessage = () => {
  const { t } = useTranslation();
  return <InfoMessage icon="info" message={t('state.no_hits_search')} />;
};

export default NoSearchResultsInfoMessage;
